import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getSystemConfig = async (config, defaultValue) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/system-config/with-default/${config}/${defaultValue}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
